import {
  DIRECT_PROPERTY_CYCLE_KEY,
  DIRECT_PROPERTY_DESCRIPTION_KEY, DIRECT_PROPERTY_LAST_GOAL_ACTIVITY_KEY,
  DIRECT_PROPERTY_PARENT_KEY,
  DIRECT_PROPERTY_PROGRESS_KEY,
} from '@/lib/constants';
import { goal as goalConfig } from 'shared/api/query/configs.json';
import { isEmpty } from '@/lib/property-value';
import { isEmptyDocument } from '@/lib/editor/editor';
import { isNullOrUndefined } from 'shared/lib/object/object';
import { propertyVisibility } from 'shared/constants.json';

export const directPropertyEmpty = ({ attr, goal }) => {
  switch (attr) {
    case goalConfig.edges.parents:
      return goal.parents.length === 0;
    case goalConfig.edges.goalCycle:
      return goal.goalCycle.length === 0;
    case goalConfig.edges.description:
      return isEmptyDocument(goal.description);
    default:
      return false;
  }
};

export const isVisible = ({ property, goal }) => {
  if (property.goalVisibility === propertyVisibility.alwaysVisible) {
    return true;
  }

  if (property.goalVisibility === propertyVisibility.alwaysHidden) {
    return false;
  }

  if (property.isDirect) {
    switch (property.key) {
      case DIRECT_PROPERTY_PARENT_KEY:
        return goal.parents.length > 0;
      case DIRECT_PROPERTY_CYCLE_KEY:
        return goal.goalCycle.length > 0;
      case DIRECT_PROPERTY_DESCRIPTION_KEY:
        return goal.description !== null;
      case DIRECT_PROPERTY_LAST_GOAL_ACTIVITY_KEY:
        return goal.lastGoalActivity !== null && !isNullOrUndefined(goal.lastGoalActivity[0]?.message);
      case DIRECT_PROPERTY_PROGRESS_KEY:
      default:
        return false;
    }
  }

  return !isEmpty(property, goal.properties.find((p) => p.property.uid === property.uid));
};
